import _get from "lodash.get";
import check from "./check";
import getMatchers from "./getMatchers";

const aclRoute = (to, next) => {
  const metaPermissions = _get(to, "meta.permissions");
  const metaRoles = _get(to, "meta.roles");
  const metaFeatures = _get(to, "meta.features");
  const metaTier = _get(to, "meta.tier");

  const thereIsRule = [metaPermissions, metaRoles, metaFeatures, metaTier].some(
    routeRule => routeRule
  );

  if (!thereIsRule) {
    return next();
  }

  const matchers = getMatchers({
    permissions: metaPermissions,
    roles: metaRoles,
    features: metaFeatures,
    tier: metaTier
  });

  if (check(matchers)) {
    return next();
  }

  return next("/forbidden");
};

export default aclRoute;
